<template>
  <div class="ssoLogin">
    <img
      class="background1"
      :src="imgs.loginSvg1"
    >
    <div class="background2" />
    <div class="loginBox">
      <div class="leftBox">
        <img
          class="leftSvg"
          :src="imgs.loginSvg2"
        >
        <div class="title">
          {{ pageConfig.title }}
        </div>
        <div class="slogan">
          {{ pageConfig.slogan }}
        </div>
      </div>
      <div class="ssoIframe">
        <img
          class="wujiLogo"
          :src="pageConfig.icon || imgs.wujiLogo"
        >
        <iframe
          :src="iframePath"
          frameborder="0"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { $t } from '@/sso_common/i18n';
import { computed, reactive } from '@vue/composition-api';
import loginSvg1 from '@assets/sso_login_background1.svg';
import loginSvg2 from '@assets/sso_login_background2.svg';
import wujiLogo from '@assets/logo.png';

export default {
  components: {},
  setup() {
    if (location.protocol !== 'https:') {
      location.replace(`https:${location.href.substring(location.protocol.length)}`);
    }
    const iframePath = computed(() => {
      const newLoginConfig = window.WUJI_SSO_NEW_LOGIN;
      if (newLoginConfig) {
        const { host } = newLoginConfig;
        return `${'https://'}${host}/sso/choose_port?via=${host}`;
      }
      return `/sso/choose_port?via=${document.domain}`;
    });
    // i18n ignore next line
    const defaultTitle = '无极';
    // i18n ignore next line
    const defaultSlogan = '专业，全生命周期的管理端低代码平台';

    const title = window.WUJI_SSO_DEFAULT_LOGIN_PAGE?.title === defaultTitle ? $t('k_d8a2afad') : window.WUJI_SSO_DEFAULT_LOGIN_PAGE?.title;
    const slogan = window.WUJI_SSO_DEFAULT_LOGIN_PAGE?.slogan === defaultSlogan ? $t('k_a2eac71e') : window.WUJI_SSO_DEFAULT_LOGIN_PAGE?.slogan;
    const pageConfig = reactive({
      icon: '',
      ...window.WUJI_SSO_DEFAULT_LOGIN_PAGE,
      title,
      slogan,
    });

    const imgs = reactive({
      loginSvg1,
      loginSvg2,
      wujiLogo,
    });

    return { iframePath, imgs, pageConfig };
  },
};
</script>

<style lang="scss" scoped>
$iframe-padding: 17px;

.background1 {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: -1;
  box-sizing: border-box;
  padding: 16px 0;
}
.background2 {
  width: 100%;
  height: 100%;
  position: absolute;
  background: linear-gradient(264.7deg, #85afee 0.81%, #7677ed 99.73%);
  z-index: -2;
}

.ssoLogin {
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ssoIframe {
    border-radius: 10px;
    box-shadow: (-$iframe-padding) (-$iframe-padding) 0 0 rgb(255 255 255 / 50%);
    margin-left: $iframe-padding;
    margin-top: $iframe-padding;
    background-color: white;
    display: flex;
    gap: 14px;
    flex-direction: column;
    align-items: center;
  }

@media (min-width: 769px) {
  .ssoIframe {
    height: 503px;
    width: 368px;
   .wujiLogo{
      margin-top: 42px;
      width: 92px;
      height: 92px;
   }
    >iframe{
      width: 300px;
      height: 318px;
    }
  }
  .loginBox {
    display: flex;
    flex-direction: row;
    gap: 11vw;
    .leftBox {
      margin-top: 62px;
    }
    .leftSvg {
      margin-left: 32px;
      width: 371px;
      height: 245px;
      margin-bottom: 50px;
    }
    .title {
      font-size: 41px;
      line-height: 42px;
      margin-bottom: 16px;
      color: var(--td-font-white-1);
    }
    .slogan {
      font-size: 25px;
      line-height: 42px;
      color: var(--td-font-white-1);
    }
  }
}

@media (max-width: 768px) {
  .ssoIframe {
    height: 350px;
    width: 280px;
   .wujiLogo{
      margin-top: 32px;
      width: 72px;
      height: 72px;
   }
    >iframe{
      width: 240px;
      height: 218px;
    }
  }
  .loginBox {
    display: flex;
    flex-direction: column;
    align-items: center;
    .leftBox {
      margin-top: 0;
    }
    .leftSvg {
      margin-left: 0;
      width: 250px;
      height: 100px;
      margin-bottom: 10px;
    }
    .title {
      font-size: 28px;
      line-height: 32px;
      margin-bottom: 12px;
      color: var(--td-font-white-1);
      text-align: center;
    }
    .slogan {
      font-size: 18px;
      line-height: 32px;
      color: var(--td-font-white-1);
      text-align: center;
      margin-bottom: 20px;
    }
  }
}
</style>
